import { UserNormalText } from '../user-msg/user-text';
import { UserMsgWrapper } from '../msg-wrapper';
import { AiMessageComponent, MountedWrapper } from '../ai-msg';
import { SubMsgBaseProps } from '../../types/comp-block';
import { MsgSenderRole } from '../../types';
import { useChatPageStore, useResetMsgListScroll } from '../../store';
import { useShallow } from 'zustand/shallow';
import { useRef } from 'react';
import mixpanel from 'mixpanel-browser';
import { Skeleton } from '@leadsnavi/ui-kit';

export const MsgListComponent: React.FC<
  Pick<SubMsgBaseProps, 'dialogWrpperRef'> & {
    noData?: React.ReactNode;
  }
> = props => {
  const { dialogWrpperRef, noData } = props;
  const sessionId = useChatPageStore(state => state.sessionId);
  const msgList = useChatPageStore(useShallow(store => store.msgList));
  const listWrapperRef = useChatPageStore(store => store.getListWrapperRef)();
  const handleScroll = useChatPageStore(store => store.handleScroll);
  const handleWheel = useChatPageStore(store => store.handleWheel);
  const scrollToBottom = useChatPageStore(store => store.scrollToBottom);
  const lastestSseMessageId = useChatPageStore(store => store.lastestSseMessageId);
  const showSkeleton = useChatPageStore(store => store.showSkeleton);
  const traceMessageIdRef = useRef('');
  useResetMsgListScroll();
  console.log(1111, msgList);
  return (
    <div
      className="msg-list  h-full es-scrollbar  overflow-auto pb-20"
      ref={listWrapperRef}
      onScroll={handleScroll}
      onWheel={handleWheel}
    >
      <div className="max-w-[800px] w-5/6 mx-auto">
        {showSkeleton ? (
          <div className="space-y-[10px] pt-5">
            <Skeleton className="size-[14px]  rounded-[2px] w-[70%] shrink-0" />
            <Skeleton className="size-[14px]  rounded-[2px] w-full shrink-0" />
            <Skeleton className="size-[14px]  rounded-[2px] w-[90%] shrink-0" />
            <Skeleton className="size-[14px]  rounded-[2px] w-full shrink-0" />
          </div>
        ) : null}
        {/* 如果有消息，则增加40高度，避免直接接触顶部 */}
        {msgList && msgList.length > 0 ? <div className="h-10"></div> : null}

        {!showSkeleton && msgList.length === 0 && noData ? noData : null}

        {msgList.map((item, idnex) => {
          if (!(item && item.messageId)) return null;

          if (item.senderRole === MsgSenderRole.Assistant && !traceMessageIdRef.current) {
            traceMessageIdRef.current = item.messageId;
            mixpanel.track('chat_result_view');
          }

          let el: React.ReactNode;
          if (item.senderRole === MsgSenderRole.User) {
            el = (
              <UserMsgWrapper msg={item}>
                <UserNormalText subMsg={item.subMessage[0]} sessionId={sessionId} />
              </UserMsgWrapper>
            );
          } else if (item.senderRole === MsgSenderRole.Assistant) {
            el = (
              <AiMessageComponent
                dialogWrpperRef={dialogWrpperRef}
                data={item}
                sessionId={sessionId}
                isLatest={idnex === msgList.length - 1}
              />
            );
          }

          return (
            <div
              className="mb-10"
              id={item.messageId === traceMessageIdRef.current ? 'chat_result_view' : ''}
              key={item.messageId}
              data-message-id={item.messageId}
            >
              <MountedWrapper onMounted={lastestSseMessageId === item.messageId ? scrollToBottom : undefined}>
                {el}
              </MountedWrapper>
            </div>
          );
        })}
      </div>
    </div>
  );
};
